import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import api from '../../../../components/api';

function useRoutesRoute() {
  /* state management for react query fetch management */
  const { isLoading, data, error } = useQuery(
    ['getAll', 'routes'],
    () => api.routes.getAll(),
  );

  const navigate = useNavigate();
  const onNavigateToDetail = (id: string) => navigate(`/routes/route/${id}`);

  return {
    data, isLoading, error, onNavigateToDetail,
  };
}

export default useRoutesRoute;
